import React, { Ref, forwardRef } from "react";

import * as S from "./style";

type TextAreaProps = {
  label: string;
  isRequired?: boolean;
  value: string;
  error?: string;
  maxLength?: number;
  height?: number;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  name: string;
  disabled?: boolean;
  ["data-testid"]?: string;
};

export const TextArea = forwardRef(function TextAreaInner(
  {
    label,
    isRequired,
    error,
    value,
    maxLength,
    height,
    onChange,
    name,
    onBlur,
    ...rest
  }: TextAreaProps,
  ref: Ref<HTMLTextAreaElement> | null
) {
  const shouldShowCounter = !!maxLength;
  const shouldShowErrorMessage = !!error;
  const shouldJustifyEnd = shouldShowCounter && !shouldShowErrorMessage;

  return (
    <S.InputWithErrorWrapper>
      <S.Label htmlFor={name}>
        {label}
        {isRequired && <S.RequiredSpan>*</S.RequiredSpan>}
      </S.Label>
      <S.StyledTextArea
        onBlur={onBlur}
        ref={ref}
        hasError={shouldShowErrorMessage}
        value={value}
        maxLength={maxLength}
        height={height}
        onChange={onChange}
        name={name}
        id={name}
        {...rest}
      />
      {(shouldShowErrorMessage || shouldShowCounter) && (
        <S.BottomWrapper shouldJustifyEnd={shouldJustifyEnd}>
          {shouldShowErrorMessage && <S.ErrorMessage>{error}</S.ErrorMessage>}
          {shouldShowCounter && (
            <S.Counter>
              {value.length}/{maxLength}
            </S.Counter>
          )}
        </S.BottomWrapper>
      )}
    </S.InputWithErrorWrapper>
  );
});
